import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { ShowErrorToast, ShowSuccessToast } from '../../components/toaster/toast.jsx';

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("New Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true); // Start loading
      try {
        const res = await ApiService.changePassword(values,token);
        if(res.status == 200){
          ShowSuccessToast(`Password Changed Successfully`);
          navigate('/login')
        }
      } catch (error) {
        console.log("error", error);
        ShowErrorToast(
          error?.response?.data?.error ||
            "Something went wrong, please try again!"
        );
      } finally {
        setLoading(false); // Stop loading
      }
    },
  });

  return (
    <div className="flex flex-col bg-custom-gradient text-white h-screen">
      <div className="px-10 py-3 w-full flex items-center">
        <img src="/images/cards/pacific.png" alt="Company Logo" />
      </div>
      <div className="flex flex-col md:flex-row gap-10 lg:gap-40 md:gap-20 md:items-start sm:items-center justify-center flex-grow pt-5 xl:pt-10 2xl:pt-32 md:px-0 px-6">
        <div className="">
          <h1 className="md:text-4xl text-2xl font-semibold mb-4">
            Reset Your <br /> Password
          </h1>
        </div>

        {/* <div className="w-full lg:w-1/2 flex "> */}
        <div className="bg-white text-gray-900 p-10 rounded-lg shadow-lg w-full max-w-md">
          <form className="space-y-5" onSubmit={formik.handleSubmit}>
            <div>
              <label className="block text-sm font-medium mb-2">
                New Password
              </label>
              <div className="relative">
                <input
                  name="newPassword"
                  type={showPassword ? "text" : "password"}
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="••••••••"
                  className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute top-1/2 right-4 transform -translate-y-1/2"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {formik.touched.newPassword && formik.errors.newPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {formik.errors.newPassword}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Confirm Password
              </label>
              <div className="relative">
                <input
                  name="confirmPassword"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute top-1/2 right-4 transform -translate-y-1/2"
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {formik.touched.confirmPassword &&
                formik.errors.confirmPassword && (
                  <p className="text-red-500 text-sm mt-1">
                    {formik.errors.confirmPassword}
                  </p>
                )}
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="md:w-[40%] w-full bg-orangeColor text-white px-4 py-1.5 rounded-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400"
              >
                Reset Password
              </button>
            </div>
          </form>
        </div>
        <img
          src="/images/sitar.png"
          alt="Sitar"
          className="absolute bottom-0 left-0 hidden md:block"
        />
        {/* </div> */}
      </div>
      <footer className="sticky bottom-0 text-center py-4 w-full  text-white">
        © 2025 Pacific Cross. All Rights Reserved.
      </footer>
    </div>
  );
};

export default ResetPassword;
